import {isValidPolicyNumberPaperElectronic} from 'ApplicationEntry/models/EnteredPolicyNumber';
import * as P from 'ApplicationEntry/models/ProductsRiders/PinCare/PinCare';
import * as GP from 'ApplicationEntry/models/ProductsRiders/PinCare/GroupPinCare';
import React, {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import * as ErrorMessages from '../../ErrorMessages';
import './../ProductRiders.sass';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import States from 'ApplicationEntry/models/States';
import PackageSelect from '../PackageSelect';
import {CaseDetails} from 'ApplicationEntry/models/CaseDetails';
import * as BAActions from 'ApplicationEntry/ducks/billingAgent';
import * as AIPActions from 'ApplicationEntry/ducks/ProductsRiders/aip';
import * as AActions from 'ApplicationEntry/ducks/ProductsRiders/accident';
import * as ANYActions from 'ApplicationEntry/ducks/ProductsRiders/accidentNewYork';
import * as PActions from 'ApplicationEntry/ducks/ProductsRiders/pinCare';
import * as CIActions from 'ApplicationEntry/ducks/ProductsRiders/criticalIllness';
import * as CINYActions from 'ApplicationEntry/ducks/ProductsRiders/criticalIllnessNY';
import * as GWLActions from 'ApplicationEntry/ducks/ProductsRiders/iwl';
import * as GLTActions from 'ApplicationEntry/ducks/ProductsRiders/glterm';
import * as GULActions from 'ApplicationEntry/ducks/ProductsRiders/universalLife';
import * as SActions from 'ApplicationEntry/ducks/ProductsRiders/shop';
import * as DActions from 'ApplicationEntry/ducks/ProductsRiders/disability';
import * as CActions from 'ApplicationEntry/ducks/ProductsRiders/cancer';

type PinCareProps = {
  caseDetails: CaseDetails;
  pinCare: P.PinCare;
};

const PinCare = (props: PinCareProps) => {
  const dispatch = useDispatch();
  const {
    packageName,
    planType,
    calculatedPremium,
    cwa,
    policyNumber,
    replacement,
    units,
    jStamp,
    situsState,
    packageList,
  } = props.pinCare;
  const [situsLabel, setSitusLabel] = useState<HTMLLabelElement | null>();
  const [planTypeBlurred, setBlurPlanType] = useState(false);
  const [policyNumberBlurred, setPolicyNumberBlurred] = useState(false);
  const showPlanTypeError = planTypeBlurred && planType.key === 'Empty';
  const [planTypeLabel, setPlanTypeLabel] = useState<HTMLLabelElement | null>();
  const showPolicyNumberError = policyNumberBlurred && !isValidPolicyNumberPaperElectronic(policyNumber) && replacement;
  const caseNumber = props.caseDetails.key === 'ValidGroupCaseDetails' ? props.caseDetails.caseNumber.Data : '';

  useEffect(() => {
    dispatch(PActions.getGroupPinCareProducts(caseNumber, 'PINCARE'));
  }, [caseNumber, dispatch]);

  return (
    <>
      <div className="product-riders-section__policy-type" id="pin-care-section">
        <form noValidate autoComplete="off" className="product-riders-section__policy-type__form">
          <div className="product-riders-section__policy-type__form__row">
            <Grid container spacing={4}>
              <PackageSelect
                packageName={packageName}
                packageList={packageList}
                changePackageAction={PActions.changePackage}
                handlePackageItems={(packageItem: object) => dispatch(PActions.changePackageItem(packageItem))}
              />
              <Grid item xs={12} md={3}>
                <FormControl variant="outlined" className="product-riders-section__policy-type__form__row--field">
                  <InputLabel
                    id="pin-care-units-label"
                    className={'product-riders-section__policy-type__form__row--label'}
                  >
                    Units
                  </InputLabel>
                  <Select
                    labelId="pin-care-label-units"
                    id="pin-care-units"
                    value={units.key === 'Empty' ? '' : units.value}
                    onChange={event => dispatch(PActions.changeUnits(event.target.value as string))}
                    disabled
                    displayEmpty
                  >
                    {Object.entries(GP.units).map(tuple => (
                      <MenuItem value={tuple[1]} key={tuple[1]}>
                        {tuple[1]}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControlLabel
                  control={
                    <Checkbox name="checkedB" color="secondary" id="pin-care-j-stamp" disabled checked={jStamp} />
                  }
                  label={<Typography className="case-details-section__checkbox-label">J-Stamp</Typography>}
                  className="product-riders-section__policy-type__form__row--field"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControl
                  error={showPlanTypeError}
                  variant="outlined"
                  className="product-riders-section__policy-type__form__row--field"
                >
                  <InputLabel ref={setPlanTypeLabel} id="pin-care-plan-type-label">
                    Plan Type
                  </InputLabel>
                  <Select
                    labelId="pin-care-label-plan-type"
                    labelWidth={planTypeLabel?.clientWidth}
                    id="pin-care-plan-type"
                    value={planType.key === 'Empty' ? '' : planType.value}
                    onBlur={() => setBlurPlanType(true)}
                    onChange={event => {
                      dispatch(PActions.changePlanType(event.target.value as string));
                    }}
                  >
                    <MenuItem value="IND">Individual</MenuItem>
                    <MenuItem value="FAMILY">Family</MenuItem>
                    <MenuItem value="EMP+SPOUSE">Emp+Spouse</MenuItem>
                    <MenuItem value="EMP+CHILDREN">Emp+Children</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControl variant="outlined" className="product-riders-section__policy-type__form__row--field">
                  <InputLabel ref={setSitusLabel} id="pin-care-situs-label">
                    Situs State
                  </InputLabel>
                  <Select
                    labelId="pin-care-label-situs"
                    labelWidth={situsLabel?.clientWidth}
                    id="pin-care-situs"
                    value={situsState.key === 'Empty' ? '' : situsState.value}
                    onChange={e => {
                      dispatch(PActions.changeSitusState(e.target.value as string));
                      dispatch(BAActions.changeState(e.target.value as string));
                    }}
                    displayEmpty
                  >
                    {States.map(stateCode => (
                      <MenuItem key={stateCode} value={stateCode}>
                        {stateCode}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={3}>
                <TextField
                  id="pin-care-premium"
                  label="Premium"
                  variant="outlined"
                  placeholder="Enter Premium"
                  margin="normal"
                  fullWidth
                  className="product-riders-section__policy-type__form__row--field"
                  value={calculatedPremium.value}
                  onChange={event => {
                    dispatch(PActions.changePremium(event.target.value as string));
                    dispatch(PActions.changeCalculatedPremium(event.target.value as string));
                  }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  id="pin-care-cwa"
                  label="CWA"
                  variant="outlined"
                  placeholder="Enter CWA"
                  margin="normal"
                  fullWidth
                  className="product-riders-section__policy-type__form__row--field"
                  value={cwa.value}
                  onChange={event => dispatch(PActions.changeCWA(event.target.value as string))}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="checkedB"
                      color="secondary"
                      id="pin-care-replacement"
                      checked={replacement}
                      onChange={() => dispatch(PActions.changeReplacement(!replacement))}
                    />
                  }
                  label={<Typography className="case-details-section__checkbox-label">Replacement</Typography>}
                  className="product-riders-section__policy-type__form__row--field"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  id="pin-care-policy-number"
                  label="Policy Number"
                  variant="outlined"
                  placeholder="Enter Policy Number"
                  margin="normal"
                  fullWidth
                  error={showPolicyNumberError}
                  helperText={showPolicyNumberError ? ErrorMessages.INVALID_POLICY_NUMBER : ''}
                  className="product-riders-section__policy-type__form__row--field"
                  value={policyNumber.key !== 'ValidPolicyNumber' || !replacement ? '' : policyNumber.value.value}
                  onBlur={() => setPolicyNumberBlurred(true)}
                  onChange={event => dispatch(PActions.changePolicyNumber(event.target.value as string))}
                  disabled={!replacement}
                  inputProps={{
                    maxLength: 10,
                  }}
                />
              </Grid>
            </Grid>
          </div>
        </form>
      </div>
    </>
  );
};

export default PinCare;
